import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  receiptVouchersSlice,
  receiptVouchersState,
  receiptVoucher,
} from './ReceiptVouchersSlice';
import { addReceiptVoucherSlice } from './AddModal/AddModalSlice';

// API
import  { sortDirectionType } from '../../services/api/api';

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar';

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader';
import AddModal from './AddModal/AddModal';

import { Confirm } from '../../components/Alerts/Alerts';
import { havePermission } from '../../services/hoc/permissions';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { PrintEssal } from '../../components/print/print_essal';
import { Print } from '@mui/icons-material';
import { IconButton } from '../../components/icon-button';
import { getListSort } from '../../services/hoc/sort';
import { SortTable } from '../../components/Table/SortTable';
import { RowContainer } from '../../components/Table/row_container';
import { useAPI } from '../../services/hoc/useAPI';
import { AxiosError } from 'axios';
import { useNotification } from '../../services/usenotification';

const RecieptVoucher =() => {
  // Translation
  const t = useTranslation();
  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });
  // Redux
  const dispatch = useDispatch();
  const location = useLocation();
  const {alertError500}=useNotification()
  const [showModal,setShowModal]=useState({open:false,id:0})
  const keyword_ref = useRef<string|null>(null)
    const sort_fields = useRef<{sort_field?:number,sort_direction?:sortDirectionType}>({})
  const state = useSelector(
    (state: { receipt_vouchers: receiptVouchersState }) =>
      state.receipt_vouchers,
  );

  // Hooks

  const [printEssal, setPrintEssal] = useState<{ show: boolean; data: any }>({
    show: false,
    data: {},
  });
const ENDPOINTS = useAPI()
  // Search
  const search = (value: string) => {

    dispatch(receiptVouchersSlice.actions.reset());
    keyword_ref.current=Boolean(value)?value:null

    fetchData(1,Boolean(value)? 20:8, value);
  };

  // Fetch Data
  const fetchData = useCallback((
    page: number,
    page_size: number = 10,
    keyword: string = '',
    sort_direction?:sortDirectionType,
    sort_field?:number

  ) => {
    dispatch(receiptVouchersSlice.actions.setIsFetching(true));
    keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
    ENDPOINTS.receipt_vouchers()
      .index({ page, page_size, keyword ,sort_direction:sort_direction,sort_field :sort_field})
      .then((response: any) => {
        dispatch(receiptVouchersSlice.actions.setIsFetching(false));
        dispatch(receiptVouchersSlice.actions.setPage(pagesInfo.page));
        // if (response.data.data.last_page)
        //   setPagesInfo((pre) => ({
        //     ...pre,
        //     lastPage: response.data.data.last_page,
        //   }));
        let receiptVouchers: receiptVoucher[] = response.data.data.vouchers.map(
          (receiptVoucher: any): receiptVoucher => receiptVoucher,
        );

        dispatch(
          receiptVouchersSlice.actions.init(receiptVouchers),
        );
        dispatch(
          receiptVouchersSlice.actions.setHasMore(
            page < Number(response.data.data.last_page),
          ),
        );

        if (!state.isLoaded)
          dispatch(receiptVouchersSlice.actions.setIsLoaded(true));
      })
      .catch((err:AxiosError)=> {
         dispatch(receiptVouchersSlice.actions.setIsFetching(false));
         alertError500(err)
         
      })
  },[ENDPOINTS,dispatch,pagesInfo.page,state.isLoaded])

  const fetchSortedData =useCallback((sort_field:number,sort_direction:sortDirectionType)=>{
    if (sort_direction && sort_field){
    
      sort_fields.current.sort_direction=sort_direction 
      sort_fields.current.sort_field=sort_field
      //setSortOptions(pre=>({...pre,sort_direction,sort_field}))
      fetchData(state.page,8,'',sort_direction,sort_field)
    }
  },[state.page])


  const print =(receiptVoucher:receiptVoucher)=> (
          
    <div style={{display:'flex'}}>
    <IconButton
    value={false}
    doTitle={t("print_voucher")}
   disabled={!havePermission("Print Receipt Voucher")}
    cancelTitle={t('cancel_invoice_issued')}
    doFunction={() => {
      setPrintEssal((pre) => ({
               ...pre,
               show: true,
               data: receiptVoucher,
             }));
           
        return true;
      }
    }
    DoIcon={<Print style={{ color: 'var(--primary-color)' }} />}
  />
 </div>
  )
  const actions =(receiptVoucher:receiptVoucher)=>(
    <div className="show-on-hover">
      {havePermission('Show Receipt Voucher') ? (
        <Tooltip title={t('info')}>
          <i
            className="icon-info"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              // dispatch( showReciptVoucherSlice.actions.setIsOpen({ id: receiptVoucher.id, isOpen: true }) )
              setShowModal(pre=>({...pre ,open:true,id:  receiptVoucher.id}))
              // dispatch(
              //   addReceiptVoucherSlice.actions.setIsOpen(true),
              // );
              dispatch(
                addReceiptVoucherSlice.actions.setIsLoading(true),
              );
              dispatch(
                addReceiptVoucherSlice.actions.setEditId(
                  receiptVoucher.id,
                ),
              );
              ENDPOINTS.receipt_vouchers()
                .show({ id: receiptVoucher.id })
                .then((response: any) => {
                  dispatch(
                    addReceiptVoucherSlice.actions.set({
                      ...response.data.data,
                      client_name: response.data.data.client?.name,
                      order_no: response.data.data.order?.order_no,
                      date: response.data.data.date.replace(
                        /\//g,
                        '-',
                      ),
                    }),
                  );
                  dispatch(
                    addReceiptVoucherSlice.actions.setIsLoading(
                      false,
                    ),
                  );
                });
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
      {/* havePermission("Edit Receipt Voucher") ?
                  <i className="icon-edit" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                      e.stopPropagation()
                      dispatch( addReceiptVoucherSlice.actions.setIsOpen(true) )
                      dispatch( addReceiptVoucherSlice.actions.setIsLoading(true) )
                      dispatch( addReceiptVoucherSlice.actions.setEditId(receiptVoucher.id) )
                      ENDPOINTS.receipt_vouchers().show({ id: receiptVoucher.id })
                      .then((response: any) => {
                          dispatch( addReceiptVoucherSlice.actions.set({
                              ...response.data.data,
                              client_name: response.data.data.client?.name,
                              order_no: response.data.data.order?.order_no,
                              date: response.data.data.date.replace(/\//g, "-")
                          }) )
                          dispatch( addReceiptVoucherSlice.actions.setIsLoading(false) )
                      })
                  } } /> : "" */}
      {havePermission('Delete Receipt Voucher') ? (
        <Tooltip title={t('delete')}>
          <i
            className="icon-delete"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(receiptVoucher.id),
              });
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
    </div>
  )
  const rows =()=>{
    return (
      state.receiptVouchers[state.page]
      ? state.receiptVouchers[state.page].map((receiptVoucher, index) => {
        return (
          <RowContainer 
          item_id={receiptVoucher.id.toString()}
          onSelect={toggleSelectedId}
          state_length={state.receiptVouchers[state.page].length}
          tr_index={index}
          columns={[
            receiptVoucher.voucher_no,
            receiptVoucher.date,
            receiptVoucher.client_name,
            receiptVoucher.order_no,
            receiptVoucher.value,
            print(receiptVoucher),
            actions(receiptVoucher)
          ]}
          />
        )
      }):null
    )
    }

  // Toggle Selected id
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const toggleSelectedId = (id: string) => {
    if (!havePermission('Delete Receipt Voucher')) return;
    let index = selectedIds.findIndex((selectedId) => selectedId === id);
    if (index !== -1) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else setSelectedIds([...selectedIds, id]);
  };

  // Delete
  const remove = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(receiptVouchersSlice.actions.setIsLoading(true));
    ENDPOINTS.receipt_vouchers()
      .delete({ ids })
      .then(() => {
        setSelectedIds([]);
        dispatch(receiptVouchersSlice.actions.setIsLoading(false));
        dispatch(receiptVouchersSlice.actions.deleteReceiptVouchers(ids));
      })
      .catch((err:AxiosError)=>{
        alertError500(err)
          dispatch(receiptVouchersSlice.actions.setIsLoading(false));
      })
  };

  // First fetch
  useEffect(() => {
    if (location.state) {
      if (!state.isFetching) {
       search(location.state.key)
      }
    } else {
      if (!state.isLoaded && !state.isFetching) {
        fetchData(1);
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (pagesInfo && pagesInfo.page !== state.page) {
  
      if (!state.isFetching) {
        receiptVouchersSlice.actions.setPage(pagesInfo.page);
        fetchData(pagesInfo.page,8,'',sort_fields.current.sort_direction,sort_fields.current.sort_field);
      }
    }
  }, [pagesInfo.page]);


  
  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isLoading ? <WhiteboxLoader /> : ''}
          <TableActionBar
            title={t('receipt_vouchers')}
            keyword={location.state ? location.state.key : ''}
            search={search}
            showFilter={false}
            showDelete={selectedIds.length > 0}
            delete={() => {
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(),
              });
            }}
            addText={t('add_to_receipt_vouchers')}
            add={havePermission('Add Receipt Voucher')?
               () =>   setShowModal(pre=>({...pre ,open:true,id:  0}))
               : undefined
                
            }
          />

          {/* <DashboardTable
            
            header={[
              t('voucher_no'),
              t('date'),
              t('client'),
              t('order_no'),
              t('amount'),
              t("print_voucher"),
              '',
            ]}
            body={generateData()}
            onSelect={toggleSelectedId}
            hasMore={state.hasMore}
            loadMore={fetchData}
            pagesInfo={pagesInfo}
            setPagesInfo={setPagesInfo}
            sort_fields={getListSort(['voucher_no'
            ,'date','client_name','order_no','value','print_voucher'
            ,''],'Receipt_Voucher')}
            fetchSortedData={fetchSortedData}
          /> */}
          <SortTable
            header={[
              t('voucher_no'),
              t('date'),
              t('client'),
              t('order_no'),
              t('amount'),
              t("print_voucher"),
              '',
            ]}
           state={state.receiptVouchers[state.page]??[]}
            onSelect={toggleSelectedId}
            hasMore={state.hasMore}
            loadMore={fetchData}
            pagesInfo={pagesInfo}
            setPagesInfo={setPagesInfo}
            sort_fields={getListSort(['voucher_no'
            ,'date','client_name','order_no','value','print_voucher'
            ,''],'Receipt_Voucher')}
            fetchSortedData={fetchSortedData}
           >
            <>
            {
              rows()
            }
            </>

          </SortTable>

{showModal && <AddModal showModal={showModal.open} id={showModal.id}
             closeModal={()=>setShowModal(pre=>({...pre ,open:false}))} />}

      
          {printEssal.show && (
            <PrintEssal
              close={() => setPrintEssal((pre) => ({ ...pre, show: false }))}
              data={printEssal.data}
              is_payment={false}
            />
          )}
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
export default RecieptVoucher ;
